var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HrLine container"},[_c('hr',{class:{'is-blue' : _vm.blue === true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }